import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { OrderReceiptService } from '../../services/order-receipt.service';
import { sampleCart } from './cart-receipt-sample-cart.const';

@Component({
  selector: 'up-order-receipt',
  templateUrl: './cart-receipt.component.html',
  styleUrls: ['./cart-receipt.component.scss']
})
export class CartReceiptComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderReceiptService: OrderReceiptService,
  ) {
    this.merchantLink = this.route.snapshot.queryParams.merchantLink;
    this.cartId = this.route.snapshot.paramMap.get('cartId');
  }

  public totalDrs = 0;

  public cart: any;
  public order = null;
  public merchantLink: string;
  public cartId: string;
  public loading = true;

  async ngOnInit() {
    await this.initialize();
  }

  async initialize() {
    if (this.cartId === '204984') {
      this.cart = sampleCart;
      this.loading = false;
    }
    else if (this.merchantLink && this.cartId) {
      await this.orderReceiptService
        .getCartByIdAndMerchantLink(this.cartId, this.merchantLink)
        .toPromise()
        .then(
          async (response) => {
            if (response.orderLink) {
              // Redirect to order receipt
              this.router.navigate(['/view'], {
                queryParams: {
                  orderLink: response.orderLink,
                  merchantLink: this.merchantLink
                }
              });
              return;
            }

            this.cart = response;

            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            this.router.navigate(['/error']);
            return;
          }
        );
    }
  }
}
